import React, { useState } from "react";
import { Typography } from "@mui/material";
import { PrimaryButton, SecondaryButton } from "../../common/Buttons";
import { Grid } from "@mui/material";

import { useNavigate } from "react-router-dom";
import { useTranslation } from "react-i18next";

const EpiredLink = (props) => {
  const { t } = useTranslation();
  const navigate = useNavigate();

  return (
    <>
      <Typography variant="p" fontWeight="bold" color="color.magentaDark1">
        {t("expired-link")}
      </Typography>

      <Grid container spacing={2} marginTop="1rem" className="form-buttons">
        <Grid item lg={6} width="50%">
          <SecondaryButton
            click={() => {
              navigate("/");
            }}
            title={"cancel"}
            width="100%"
            textTransform="capitalize"
          />
        </Grid>
        <Grid item lg={6} width="50%">
          <PrimaryButton
            title={t("re-enter-email")}
            click={() => {
              navigate("/forget-password");
            }}
            width="100%"
            fullWidth={true}
            textTransform="capitalize"
          />
        </Grid>
      </Grid>
    </>
  );
};

export default EpiredLink;
